import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=6f683b81&scoped=true&"
import script from "./ExamDetail.vue?vue&type=script&lang=js&"
export * from "./ExamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=6f683b81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f683b81",
  null
  
)

export default component.exports